import React from "react";
import { Trans, useTranslation } from "react-i18next";

import {
  Box,
  Button,
  CompassColor,
  Heading,
  Spacing,
  Stack,
  Text,
} from "@noom/wax-component-library";

import {
  QuestionComponentProps,
  QuestionDefinition,
} from "@/components/survey/Question";
import { InformationalScreen } from "@/components/survey/questionTypes/core";

const QUESTION_ID = "diabetesSupport";

declare module "@/contexts" {
  interface SurveyAnswers {
    diabetesSupport?: boolean;
  }
}

const DiabetesSupport: React.FC<QuestionComponentProps> = ({ onClickNext }) => {
  const { t } = useTranslation();

  return (
    <InformationalScreen questionId={QUESTION_ID}>
      <Stack spacing={Spacing[8]} alignItems="stretch">
        <Box>
          <Heading
            fontSize="40px"
            fontWeight={400}
            lineHeight="52px"
            color={CompassColor.white}
            mb="28px"
          >
            <Trans i18nKey="diabetesSupport.heading" />
          </Heading>
          <Text fontSize="18px" lineHeight="26px" color={CompassColor.white}>
            <Trans i18nKey="diabetesSupport.body" />
          </Text>
        </Box>
        <Box
          alignItems="center"
          display="flex"
          flexDirection="column"
          marginTop="var(--spacing-xl)"
        >
          <Button
            colorScheme="primary"
            onClick={() => onClickNext(true)}
            padding="unset"
            size="xl"
          >
            <Trans i18nKey="diabetesSupport.cta" />
          </Button>
        </Box>
      </Stack>
    </InformationalScreen>
  );
};

export const Q_DIABETES_SUPPORT: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["DIABETES_LIFESTYLE"],
  shouldShowQuestion: () => true,
  component: DiabetesSupport,
};
